// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3vHdo","vLegacy":"SelectSecondary_vLegacy__1s-tv","error":"SelectSecondary_error__3TpRX","disabled":"SelectSecondary_disabled__2ijGT"};